module.exports = __webpack_public_path__ + "media/customizations/fccsa/back-b78975020ef22cf6b28f210629f5d47f.jpg";